import * as React from 'react';
import * as moment from 'moment-timezone';

import ActionButton from '@crochik/pi-react/ui/material/ActionButton';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import { CustomPage } from '@crochik/pi-react/application/Page';

import './ExistingAppointment.css';
import { CardActions } from '@material-ui/core';
import App from '@crochik/pi-react/application/App';

import { Appointment } from '@crochik/schedulerapi.ts';

interface Props {

}
interface State {
    message?: string;
    appointment?: Appointment;
}

class PageContent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    async appointmentCancelled() {
        var resp = await fetch('frag/cancelledAppointment.html');
        var html = await resp.text();
        this.setState({
            ...this.state,
            message: html,
            appointment: undefined
        });
    }

    async existingAppointment(appt: Appointment) {
        var resp = await fetch('frag/existingAppointment.html');
        var html = await resp.text();
        this.setState({
            ...this.state,
            message: html,
            appointment: appt
        });    
    }

    updateState() {
        let args = App().args;
        if (args[0] === 'Cancelled') {
            this.appointmentCancelled();

        } else if (args[1]) {
            this.existingAppointment(args[1][0]);

        } else {
            console.error('missing appointment');
        }
    }

    componentWillReceiveProps() {
        this.updateState();
    }

    componentDidMount() {
        this.updateState();
    }

    renderMessage() {
        if (!this.state.appointment) return undefined;

        var date: string | undefined;
        var time: string | undefined;

        // var start = Form.get('Appointment').values['start'];
        var mStart = moment(this.state.appointment.start);
        date = mStart.format('dddd, MM/DD/YYYY');
        time = mStart.format('hh:mm A');

        if (date) {
            return (
                <div className="ExistingAppointment_body">
                    <Typography>
                        <b>{this.state.appointment.subject}</b><br />
                        {date} at {time}
                    </Typography>
                </div>
            );
        }

        return undefined;
    }

    render() {
        var html;
        if (this.state.message) {
            html = {
                __html: this.state.message
            };
        }

        var show = this.state.appointment !== undefined;

        return (
            <div className="pi-content pi-form">
                <Card className="ExistingAppointment">
                    {/* <CardHeader title="Upcoming Appointment" /> */}
                    <CardContent>
                        {html && <div dangerouslySetInnerHTML={html} />}
                        {this.renderMessage()}
                    </CardContent>
                    <CardActions>

                        {show && <ActionButton variant="text" color="primary" title="Keep" action="app.keepAppointment" />}
                        <ActionButton variant="text" color="primary" title="Re-schedule" action="page.Calendar.show" />
                        {show && <ActionButton variant="text" color="primary" title="Cancel" action="app.cancelAppointment" />}
                    </CardActions>
                </Card>
            </div>
        );
    }
}

export default (name: string, title: string) => new CustomPage({ name, label: title }, <PageContent />);


// WEBPACK FOOTER //
// ./src/app/pages/ExistingAppointment.tsx